import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { variableIdentifiante } from 'src/app/shared/questionnaire.metadata';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-selecteur-questionnaire',
  templateUrl: './selecteur-questionnaire.component.html',
  styleUrls: ['./selecteur-questionnaire.component.css']
})
export class SelecteurQuestionnaireComponent implements OnInit {
  /** FormGroup du champ de sélection */
  @Input()
  formulaireSelecteur: UntypedFormGroup = new UntypedFormGroup({});
  /** Est-ce qu’un numéro de compostage est déjà sélectionner */
  @Input()
  noCmpstAffiche: boolean;
  @Output()
  charger: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  reinitialiser: EventEmitter<void> = new EventEmitter<void>();
  result: Boolean;

  constructor(
    public modeRendu: ModeRenduService
  ) { 
  }

  ngOnInit(): void {
  }

  get variableIdentifiante(): string[] {
    return variableIdentifiante;
  }

  public utiliserFilteredSelect(nomVariable: string): boolean {
    return nomVariable.substring(0, 5) === 'ielst';
  }

}
